<!-- 选择学员 -->
<template>
  <el-form-item :label="label">
    <el-input
      :modelValue="studentName"
      :placeholder="config.placeholder || '请选择'"
      clearable @focus="chooseStudent"
      @clear="chooseStudent('clear')"
    ></el-input>
  </el-form-item>
</template>

<script>
import { inject, onMounted, computed } from 'vue';

export default {
  kind: 'yq-学员弹窗选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '学员：',
    },
    campusIds: {
      type: Array,
      default: () => [],
    },
    campusnode: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const popup = inject('popup');

    function reset() {
      studentList.value = props.value;
    }

    const studentList = useQuery('studentMulti', props.value, reset);

    if (props.value.length > 0) {
      onMounted(() => {
        studentList.value = props.value;
      });
    }

    // 选择学员
    async function chooseStudent(type) {
      const node = props.campusnode;
      let campus = props.campusIds;
      if (node && node.child) {
        campus = node.child.campus;
      }
      if (type === 'clear') {
        studentList.value = [];
      } else {
        const res = await popup('student-chooser', {
          multiple: props.config.multiple,
          lists: studentList.value,
          campusIds: campus,
        });
        studentList.value = res;
      }
    }

    // 获取学员名字
    const studentName = computed(() => {
      const txt = studentList.value.map((i) => i.name);
      return txt;
    });

    return {
      reset,
      chooseStudent,
      studentName,
    };
  },
};
</script>
